<template>
  <modal class="root" ref="authModal">
    <template slot="body">
      <div class="panel-body">

        <login-form
            v-if="activeForm==='login'"
            :display-register-cta="hasRegister"
            :can-switch-forms="canSwitchForms"
            @switchForms="switchForms"
            @complete="complete"
        />
        <register-form
            v-if="activeForm==='register'"
            :display-login-cta="hasRegister"
            :can-switch-forms="canSwitchForms"
            @switchForms="switchForms"
            @complete="complete"
        />

      </div>
    </template>
  </modal>
</template>

<script>
import LoginForm from './LoginForm.vue'
import RegisterForm from './RegisterForm.vue'
import Modal from '../form/elements/Modal'

export default {
  name: "AuthModal",

  components: {
    LoginForm,
    RegisterForm,
    Modal,
  },

  props: {
    hasLogin: {
      type: Boolean,
      default: true,
    },
    hasRegister: {
      type: Boolean,
      default: true,
    },
    canSwitchForms: {
      type: Boolean,
      default: true
    },
    displayForm: {
      type: String,
      default: 'login',
    },
    reloadOnComplete: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      activeForm: null,
    }
  },

  mounted() {
    this.activeForm = this.displayForm
    window.openAuthModal = () => {
      this.$refs.authModal.openModal()
    }
  },

  methods: {
    openModal() {
      this.$refs.authModal.openModal()
    },

    complete() {
      if (this.reloadOnComplete) {
        window.location.reload(false)
      }
      this.$emit('complete')
      this.$refs.authModal.closeModal()
    },

    switchForms() {
      this.activeForm === 'login' ? this.activeForm = 'register' : this.activeForm = 'login'
    }
  },

  computed: {
    ctaText() {
      let result = {
        question: '',
        ctaLink: ''
      }

      if (this.activeForm === 'login') {
        result.question = "Don't have an account?";
        result.ctaLink = 'Register here';
      }

      if (this.activeForm === 'register') {
        result.question = "Already have an account?";
        result.ctaLink = 'Login here';
      }

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.root::v-deep {
  @import '../../../style/pages/register';
  @import '../../../../sass/login';

  .hh-modal-body {
    padding: 0 30px;
    margin-top: 0;

    @media (max-width: $screen-sm-max) {
      padding: 15px;

      .panel-body {
        padding: 0;
      }
    }
  }

  .input-label {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
  }
}
</style>